(() => {
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => [...c.querySelectorAll(s)];

  // Khatie conversion hero: product appears first, then benefits and Buy Now.
  const conversion = $('[data-conversion-hero]');
  if (conversion) {
    const slides = $$('[data-conversion-slide]', conversion);
    const contents = $$('[data-conversion-content]', conversion);
    const dots = $$('[data-conversion-dot]', conversion);
    const current = $('[data-conversion-current]', conversion);
    const stage = $('[data-conversion-stage]', conversion);
    const autoplay = conversion.dataset.autoplay !== 'false';
    const speed = Math.max(4, Number(conversion.dataset.speed || 6)) * 1000;
    let index = 0, timer = null, touchStart = 0;

    const show = (nextIndex, direction = 1) => {
      if (!slides.length) return;
      index = (nextIndex + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === index);
        slide.style.setProperty('--conversion-direction', direction);
      });
      contents.forEach((content, i) => {
        content.classList.toggle('is-active', i === index);
        content.style.setProperty('--conversion-direction', direction);
      });
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
      if (current) current.textContent = String(index + 1).padStart(2, '0');
    };
    const restart = () => {
      clearInterval(timer);
      if (autoplay && slides.length > 1) timer = setInterval(() => show(index + 1, 1), speed);
    };
    dots.forEach(dot => dot.addEventListener('click', () => {
      const nextIndex = Number(dot.dataset.conversionDot || 0);
      show(nextIndex, nextIndex >= index ? 1 : -1);
      restart();
    }));
    stage?.addEventListener('mouseenter', () => clearInterval(timer));
    stage?.addEventListener('mouseleave', restart);
    stage?.addEventListener('touchstart', e => { touchStart = e.changedTouches[0].clientX; }, {passive:true});
    stage?.addEventListener('touchend', e => {
      const dx = e.changedTouches[0].clientX - touchStart;
      if (Math.abs(dx) > 45) { show(index + (dx < 0 ? 1 : -1), dx < 0 ? 1 : -1); restart(); }
    }, {passive:true});
    conversion.classList.add('is-ready');
    show(0, 1);
    if (autoplay && slides.length > 1) timer = setInterval(() => show(index + 1, 1), speed);
  }

  const nav = $('[data-header]');
  addEventListener('scroll', () => nav?.classList.toggle('scrolled', scrollY > 20), { passive: true });
  const searchPanel = $('[data-search-panel]');
  const searchInput = $('[data-live-search]');
  const searchResults = $('[data-search-results]');
  const openSearch = () => {
    if (!searchPanel) return;
    searchPanel.classList.add('open');
    searchPanel.setAttribute('aria-hidden','false');
    setTimeout(() => searchInput?.focus(), 40);
  };
  const closeSearch = () => {
    if (!searchPanel) return;
    searchPanel.classList.remove('open');
    searchPanel.setAttribute('aria-hidden','true');
  };
  document.addEventListener('click', e => {
    const trigger = e.target.closest('[data-search-open]');
    if (trigger) { e.preventDefault(); openSearch(); }
    if (e.target.closest('[data-search-close]')) { e.preventDefault(); closeSearch(); }
  });
  searchInput?.addEventListener('keydown', e => {
    if (e.key === 'Escape') closeSearch();
    if (e.key === 'Enter') {
      e.preventDefault();
      const q = searchInput.value.trim();
      if (q) window.location.href = (window.Shopify?.routes?.root || '/') + 'search?q=' + encodeURIComponent(q) + '&type=product';
    }
  });
  searchInput?.addEventListener('input', async e => {
    const q = e.target.value.trim();
    if (!searchResults) return;
    if (q.length < 2) { searchResults.innerHTML = ''; return; }
    searchResults.innerHTML = '<div class="kh-search-empty">Finding your Khatie favourites…</div>';
    try {
      const url = (window.Shopify?.routes?.root || '/') + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
      const r = await fetch(url, {headers:{'Accept':'application/json'}, credentials:'same-origin'});
      if (!r.ok) throw new Error('search');
      const data = await r.json();
      const products = data?.resources?.results?.products || [];
      if (!products.length) {
        searchResults.innerHTML = '<div class="kh-search-empty">No products found. Try another ingredient or product name.</div>';
        return;
      }
      searchResults.innerHTML = products.map(p => {
        const image = p.image || '';
        const price = p.price ? ('₹' + Number(p.price).toLocaleString('en-IN')) : '';
        return '<a class="kh-search-result" href="' + p.url + '">'
          + (image ? '<img src="' + image + '" alt="' + (p.title || '').replace(/"/g,'&quot;') + '">' : '')
          + '<span><strong>' + (p.title || '') + '</strong><small>' + price + '</small></span></a>';
      }).join('');
    } catch (err) {
      searchResults.innerHTML = '<div class="kh-search-empty">Search is ready — press Enter to see results.</div>';
    }
  });
  $('[data-menu-toggle]')?.addEventListener('click', () => document.body.classList.toggle('menu-open'));
  // Account is intentionally a native Shopify route, with an explicit JS
  // fallback so decorative layers or theme-editor event delegation cannot
  // swallow the click.
  $$('[data-account-link]').forEach(a => a.addEventListener('click', e => {
    e.stopPropagation();
    const href = a.getAttribute('href');
    if (href) { e.preventDefault(); window.location.assign(href); }
  }));

  // Guest-order tracking: Shopify does not expose private order status to a
  // storefront theme from an arbitrary order number + email. We therefore send
  // the customer straight to Khatie WhatsApp support with the exact details.
  // Signed-in customers can track directly through Shopify Customer Accounts.
  const trackModal = $('[data-track-modal]');
  const closeTrack = () => {
    if (!trackModal) return;
    trackModal.hidden = true;
    trackModal.setAttribute('aria-hidden','true');
    document.body.classList.remove('khatie-track-open');
  };
  const openTrack = () => {
    if (!trackModal) return;
    trackModal.hidden = false;
    trackModal.setAttribute('aria-hidden','false');
    document.body.classList.add('khatie-track-open');
    setTimeout(() => $('[name="order"]', trackModal)?.focus(), 50);
  };
  document.addEventListener('click', e => {
    if (e.target.closest('[data-track-open]')) { e.preventDefault(); openTrack(); }
    if (e.target.closest('[data-track-close]')) { e.preventDefault(); closeTrack(); }
  });
  $('[data-track-form]')?.addEventListener('submit', e => {
    e.preventDefault();
    const form = e.currentTarget;
    const order = $('[name="order"]', form)?.value.trim();
    const email = $('[name="email"]', form)?.value.trim();
    const success = $('[data-track-success]', trackModal);
    if (!order || !email) return;
    const message = 'Hello Khatie, I want to track my order.\n\nOrder number: ' + order + '\nEmail used for the order: ' + email + '\n\nPlease share the latest order status and tracking details. Thank you.';
    const whatsapp = 'https://wa.me/919163580668?text=' + encodeURIComponent(message);
    if (success) {
      success.hidden = false;
      success.textContent = 'Opening Khatie WhatsApp with your order details…';
    }
    window.open(whatsapp, '_blank', 'noopener');
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeTrack(); });
  addEventListener('keydown', e => {
    if (e.key === '/' && !['INPUT','TEXTAREA'].includes(document.activeElement?.tagName)) { e.preventDefault(); openSearch(); }
    if (e.key === 'Escape') closeSearch();
  });

  const copy = {
    'Edible Oils':['Edible Oils <em>for every pour.</em>','Pure mustard oil, ready to add to your kitchen.'],
    'Spices':['Spices <em>with real character.</em>','Turmeric, coriander, chilli, jeera, black pepper and garam masala.'],
    'Grains & Flours':['Grains & Flours <em>for everyday meals.</em>','Aata, sattu and dalia and other pantry staples.'],
    'Thekua':['Thekua <em>made to share.</em>','Golden, crisp and rooted in Bihar’s food culture — made for sharing.'],
    'Pulses':['Pulses <em>for every kitchen.</em>','Everyday dals and pulses will appear here.'],
    'Combos':['Khatie Combos <em>made easy.</em>','Curated everyday essentials in one convenient pack.'],
    'Pooja Essentials':['Pooja Essentials <em>with a familiar touch.</em>','Simple pooja essentials chosen with the same care as everything we make.'],
    'Whole Products':['Whole Products <em>with full character.</em>','Whole spices, grains and everyday ingredients for familiar Indian cooking.']
  };

  const cards = () => $$('[data-product-card]');
  const categorySourceCards = (category = 'All') => {
    const all = cards();
    if (category === 'All') return all;
    return all.filter(card => matchesCategory(category, card));
  };
  const matchesCategory = (c, card) => {
    if (c === 'All') return true;
    const q = c.toLowerCase().trim();
    const t = (card.dataset.type || '').toLowerCase().trim();
    const explicit = (card.dataset.category || '').toLowerCase().trim();
    const tags = (card.dataset.tags || '').toLowerCase().split(',').map(x => x.trim()).filter(Boolean);
    const collections = (card.dataset.collections || '').toLowerCase().split(',').map(x => x.trim()).filter(Boolean);
    const title = (card.dataset.title || '').toLowerCase().trim();

    // Generic collection/combo products must never leak into a product category.
    const generic = /combo|collection|daily essentials/.test(title);
    if (q === 'combos') return collections.includes('combos') || collections.includes('combos-1') || generic || tags.includes('combo') || tags.includes('combos') || explicit === q || t === q;
    if (generic) return false;

    // Product-name matching is the primary rule. Product type is only a fallback
    // when the title itself does not reveal the category.
    if (q === 'edible oils') return collections.includes('edible-oils') || collections.includes('edible-oils-1') || /mustard\s*oil|edible\s*oil|cooking\s*oil|\boil\b/.test(title) || explicit === q || t === q;
    if (q === 'spices') return collections.includes('spices') || collections.includes('spices-1') || /chilli|turmeric|coriander|jeera|cumin|pepper|garam|masala|spice/.test(title) || tags.includes('spice') || tags.includes('spices') || explicit === q || t === q;
    if (q === 'grains & flours') return collections.includes('grains-flours') || collections.includes('grains-and-flours') || collections.includes('grains-flours-1') || /aata|atta|sattu|dalia|flour|grain/.test(title) || tags.includes('grains') || tags.includes('flours') || explicit === q || t === q;
    if (q === 'thekua') return collections.some(h => /(^|-)thekua(-|$)/.test(h)) || /thekua|thekua|shahi elaichi/.test(title) || tags.some(x => /thekua|bihari sweet/.test(x)) || /thekua/i.test(t) || explicit === q || t === q;
    if (q === 'pulses') return collections.some(h => /(^|-)pulses?(-|$)/.test(h)) || /dal|pulse|moong|chana|masoor|urad|toor|arhar|gram dal|lentil/.test(title) || tags.some(x => /pulses?|dal|lentil/.test(x)) || /pulse|dal/i.test(t) || explicit === q || t === q;
    if (q === 'pooja essentials') return collections.includes('pooja-essentials') || /pooja|puja|agarbatti|incense|diya|camphor|kapoor|havan|prasad/.test(title) || tags.includes('pooja') || tags.includes('puja') || tags.includes('pooja essentials');
    if (q === 'whole products') return collections.includes('whole-products') || tags.includes('whole products') || tags.includes('whole-products') || /whole\s+(elaichi|jeera|cumin|pepper|turmeric|dhaniya|coriander|chilli|wheat|mustard|product)/.test(title);
    return explicit === q || t === q;
  };

  function toast(message) {
    let t = $('.cart-toast');
    if (!t) { t = document.createElement('div'); t.className = 'cart-toast'; document.body.appendChild(t); }
    t.textContent = message;
    t.classList.add('show');
    clearTimeout(t._timer);
    t._timer = setTimeout(() => t.classList.remove('show'), 2200);
  }

  async function cartJSON() {
    const r = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
    if (!r.ok) throw new Error('Unable to read cart');
    return r.json();
  }

  async function refreshCartCount(cart) {
    try {
      const c = cart || await cartJSON();
      $$('[data-cart-count]').forEach(el => el.textContent = c.item_count);
      return c;
    } catch (_) { return null; }
  }

  async function addVariant(variantId, quantity = 1) {
    const res = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: {'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({items:[{id:Number(variantId), quantity:Number(quantity)}]})
    });
    if (!res.ok) {
      let msg = 'Could not add this item';
      try { const e = await res.json(); msg = e.description || e.message || msg; } catch (_) {}
      throw new Error(msg);
    }
    return res.json();
  }

  async function changeLine(key, quantity) {
    const res = await fetch((window.Shopify?.routes?.root || '/') + 'cart/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: {'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({id:key, quantity:Number(quantity)})
    });
    if (!res.ok) {
      let msg = 'Could not update your bag';
      try { const e = await res.json(); msg = e.description || e.message || msg; } catch (_) {}
      throw new Error(msg);
    }
    return res.json();
  }

  function updateSwipeHint() {
    const wrap = $('[data-inline-products-area]');
    const grid = $('[data-inline-category-grid]');
    if (!wrap || !grid) return;
    const hint = $('[data-mobile-swipe-hint]', wrap);
    if (!hint) return;
    const mobile = window.matchMedia('(max-width: 700px)').matches;
    const many = $$('.product-card', grid).length > 1;
    hint.hidden = !(mobile && many);
  }

  function renderQuickShop(category='Edible Oils') {
    const grid = $('[data-category-grid]');
    if (!grid) return;
    const source = category === 'All' ? categorySourceCards('All') : categorySourceCards(category);
    grid.innerHTML = '';
    source.forEach(c => {
      const clone = c.cloneNode(true);
      $$('.add-form, [data-buy-now], [data-card-variant]', clone).forEach(el => {
        delete el.dataset.bound;
        delete el.dataset.khatieVariantBound;
        el._khatieVariantBound = false;
      });
      grid.appendChild(clone);
    });
    grid.classList.toggle('is-empty', source.length === 0);
    bindVariantPickers(grid);
    attachProductActions(grid);
    updateSwipeHint();
  }

  function filter(category) {
    const mainGrid = $('[data-product-grid]');
    if (mainGrid) $$('[data-product-card]', mainGrid).forEach(c => c.style.display = matchesCategory(category, c) ? '' : 'none');
    const title = $('[data-category-title]'), sub = $('[data-category-sub]'), v = copy[category];
    if (v && title && sub) { title.innerHTML = v[0]; sub.textContent = v[1]; }
    $$('.filter').forEach(x => x.classList.toggle('active', (x.dataset.filter || '') === category));
    renderQuickShop(category);
  }

  function exitCategoryPage() {
    const page = $('[data-category-page]');
    if (page) { page.hidden = true; page.classList.remove('is-active'); }
    document.body.classList.remove('category-mode');
  }

  function scrollToId(id) {
    const target = document.getElementById(id);
    if (target) target.scrollIntoView({behavior:'smooth', block:'start'});
  }

  function showCategoryInline(category) {
    if (!copy[category] && category !== 'All') return false;
    exitCategoryPage();
    filter(category);
    $$('.category-pill').forEach(x => {
      const active = (x.dataset.categoryLink || '') === category;
      x.classList.toggle('active', active);
      x.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    syncViewAllLinks(category);
    const panel = $('[data-category-inline-panel]');
    const grid = $('[data-inline-category-grid]');
    const title = $('[data-inline-category-title]');
    const sub = $('[data-inline-category-sub]');
    const imageWrap = $('[data-inline-feature-image]');
    const empty = $('[data-inline-category-empty]');
    const number = $('[data-inline-category-number]');
    if (panel && grid) {
      const source = category === 'All' ? categorySourceCards('All') : categorySourceCards(category);
      grid.innerHTML = '';
      source.forEach((c, i) => {
        const clone = c.cloneNode(true);
        clone.style.animationDelay = (i * 55) + 'ms';
        grid.appendChild(clone);
      });
      bindVariantPickers(grid);
      attachProductActions(grid);
      updateSwipeHint();
      const v = copy[category];
      if (v && title && sub) { title.innerHTML = v[0]; sub.textContent = v[1]; }
      $$('[data-3d-category]', panel).forEach(img => img.classList.toggle('is-active', img.dataset['3dCategory'] === category));
      if (empty) empty.hidden = true;
      const viewAllWrap = $('[data-inline-view-all-wrap]', panel);
      if (viewAllWrap) viewAllWrap.hidden = source.length === 0;
      if (imageWrap) {
        imageWrap.innerHTML = '';
        const firstImage = source[0]?.querySelector('img');
        if (firstImage) {
          const img = firstImage.cloneNode(true);
          img.removeAttribute('loading');
          img.alt = category + ' featured product';
          imageWrap.appendChild(img);
        } else {
          imageWrap.innerHTML = '<div class="category-feature-placeholder"><span>KHATIE</span><small>Available now</small></div>';
        }
      }
      panel.hidden = false;
      panel.classList.add('is-open');
    }
    return true;
  }

  function bindVariantPickers(root = document) {
    $$('[data-card-variant]', root).forEach(chip => {
      if (chip._khatieVariantBound) return;
      chip._khatieVariantBound = true;
      chip.addEventListener('click', () => {
        const card = chip.closest('[data-product-card]');
        if (!card) return;
        $$('[data-card-variant]', card).forEach(x => x.classList.remove('is-selected'));
        chip.classList.add('is-selected');

        const id = chip.dataset.variantId || '';
        const hidden = $('input[name="id"]', card);
        if (hidden) hidden.value = id;
        const title = $('[data-selected-variant-title]', card);
        const price = $('[data-selected-variant-price]', card);
        const compare = $('[data-selected-variant-compare]', card);
        const discount = $('[data-selected-variant-discount]', card);
        if (title) title.textContent = chip.dataset.variantTitle || '';
        if (price) price.textContent = chip.dataset.variantPrice || '';
        if (compare) compare.textContent = chip.dataset.variantCompare || '';
        if (discount) discount.textContent = chip.dataset.variantDiscount ? `${chip.dataset.variantDiscount}% OFF` : '';

        const add = $('.add-btn', card);
        const buy = $('[data-buy-now]', card);
        const available = chip.dataset.variantAvailable === 'true';
        if (add) { add.disabled = !available; add.textContent = available ? 'Add to cart' : 'Sold out'; }
        if (buy) { buy.disabled = !available; buy.dataset.variantId = id; buy.textContent = available ? 'Buy now' : 'Unavailable'; }

        // A card represents ONE selected variant at a time. Never rotate through
        // every product image here because those images can belong to other variants.
        const image = $('[data-product-gallery-image]', card);
        if (image && chip.dataset.variantImage) {
          image.classList.add('variant-changing');
          image.src = chip.dataset.variantImage;
          image.removeAttribute('srcset');
          if (chip.dataset.variantImageAlt) image.alt = chip.dataset.variantImageAlt;
          requestAnimationFrame(() => setTimeout(() => image.classList.remove('variant-changing'), 180));
        }

        // Clicking the product image/title after changing a size must open that
        // exact variant, not the product's default variant.
        $$('[data-product-link]', card).forEach(link => {
          if (chip.dataset.variantUrl) link.href = chip.dataset.variantUrl;
        });
      });
    });
  }



  function initProductGalleries(root = document) {
    // Variant cards intentionally show only the selected variant image.
    // Keep this initializer for legacy non-variant galleries elsewhere in the theme.
    $$('.product-gallery:not(.product-variant-image)', root).forEach(gallery => {
      if (gallery.dataset.galleryReady) return;
      gallery.dataset.galleryReady = '1';
      const images = $$('.product-gallery-image', gallery);
      const dots = $$('[data-product-gallery-dot]', gallery);
      if (images.length < 2) return;
      let index = 0;
      const show = (next) => {
        index = (next + images.length) % images.length;
        images.forEach((img, i) => img.classList.toggle('is-active', i === index));
        dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
      };
      $('[data-product-gallery-prev]', gallery)?.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); show(index - 1); });
      $('[data-product-gallery-next]', gallery)?.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); show(index + 1); });
      dots.forEach((dot, i) => dot.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); show(i); }));
      show(0);
    });
  }

  function attachProductActions(root = document) {
    $$('.add-form', root).forEach(form => {
      if (form.dataset.bound) return;
      form.dataset.bound = '1';
      form.addEventListener('submit', async e => {
        e.preventDefault();
        const card = form.closest('.product-card'), btn = $('.add-btn', form), variant = $('input[name="id"]', form)?.value;
        if (!variant) return;
        if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
        try {
          const result = await addVariant(variant, Number($('input[name="quantity"]', form)?.value || 1));
          await refreshCartCount(result);
          toast('Added to your cart ✓');
          if (btn) btn.textContent = 'Added ✓';
          setTimeout(() => { if (btn) { btn.textContent = 'Add to cart'; btn.disabled = false; } }, 900);
        } catch (err) {
          toast(err.message);
          if (btn) { btn.textContent = 'Add to cart'; btn.disabled = false; }
        }
      });
    });


  }

  // One robust Buy Now handler for all current and dynamically cloned product cards.
  // Capture phase ensures decorative/parent handlers cannot swallow the click.
  document.addEventListener('click', async e => {
    const btn = e.target.closest('[data-buy-now]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.dataset.busy === '1' || btn.disabled) return;

    const variant = btn.dataset.variantId || $('[name="id"]', btn.closest('.product-card') || document)?.value;
    if (!variant) { toast('Please choose a product size first.'); return; }

    btn.dataset.busy = '1';
    btn.disabled = true;
    btn.textContent = 'Opening…';

    try {
      await addVariant(variant, 1);
      const root = window.Shopify?.routes?.root || '/';
      window.location.assign(root + 'checkout');
    } catch (err) {
      toast(err.message || 'Could not start checkout.');
      btn.dataset.busy = '0';
      btn.disabled = false;
      btn.textContent = 'Buy now';
    }
  }, true);

  // Homepage category anchors: keep the first category as the default and
  // switch the visual active state without depending on Shopify collections.
  document.addEventListener('click', e => {
    const pill = e.target.closest('.kh-category-nav .category-pill');
    if (!pill) return;
    $$('.kh-category-nav .category-pill').forEach(x => x.classList.toggle('active', x === pill));
  });

  // Homepage category/filter interactions.
  $$('[data-filter]').forEach(btn => btn.addEventListener('click', e => {
    e.preventDefault(); exitCategoryPage(); filter(btn.dataset.filter || 'All'); scrollToId('catalog');
  }));
  // Category navigation is delegated so it also works after Shopify Theme Editor section reloads.
  document.addEventListener('click', e => {
    const control = e.target.closest('[data-category-link]');
    if (!control || !control.closest('[data-category-bar]')) return;
    const category = control.dataset.categoryLink || '';
    if (!copy[category] && category !== 'All') return;
    e.preventDefault();
    e.stopPropagation();
    showCategoryInline(category);
    syncViewAllLinks(category);
    control.blur();
  });

  function categoryDestination(category) {
    const pill = $$('.category-pill').find(x => (x.dataset.categoryLink || '') === category);
    const collectionUrl = pill?.dataset.categoryCollectionUrl || '';
    return collectionUrl || ((window.KHATIE_ROOT || '/') + '?khatie_category=' + encodeURIComponent(category) + '#category-shop-page');
  }

  // View-all follows the real Shopify collection whenever it exists.
  // Otherwise it uses the theme's complete category fallback page.
  document.addEventListener('click', e => {
    const control = e.target.closest('[data-inline-view-all],[data-quick-view-all]');
    if (!control) return;
    const active = $$('.category-pill.active')[0]?.dataset.categoryLink || 'Edible Oils';
    const category = control.dataset.inlineViewAll || active;
    if (copy[category]) {
      control.setAttribute('href', categoryDestination(category));
      // Do not preventDefault: let the real Shopify collection load all products.
    }
  });

  function syncViewAllLinks(category) {
    const href = categoryDestination(category);
    $$('[data-inline-view-all],[data-quick-view-all]').forEach(a => a.setAttribute('href', href));
  }

  function showCategoryPage(category) {
    const page = $('[data-category-page]');
    const grid = $('[data-page-category-grid]');
    if (!page || !grid || !copy[category]) return;
    // Always build the full category page from the complete catalog, never the
    // four-product quick-shop source. This guarantees View all means ALL.
    const source = category === 'All' ? categorySourceCards('All') : categorySourceCards(category);
    grid.innerHTML = '';
    source.forEach((c, i) => {
      const clone = c.cloneNode(true);
      clone.style.animationDelay = (Math.min(i, 20) * 45) + 'ms';
      $$('.add-form, [data-buy-now], [data-card-variant]', clone).forEach(el => {
        delete el.dataset.bound;
        delete el.dataset.khatieVariantBound;
        el._khatieVariantBound = false;
      });
      grid.appendChild(clone);
    });
    grid.dataset.productCount = String(source.length);
    const title = $('[data-page-category-title]'), sub = $('[data-page-category-sub]'), count = $('[data-page-category-count]');
    if (title && sub) { title.innerHTML = copy[category][0]; sub.textContent = copy[category][1]; }
    if (count) count.textContent = source.length + ' products available';
    page.hidden = false;
    page.classList.add('is-active');
    document.body.classList.add('category-mode');
    $$('.category-pill').forEach(x => x.classList.toggle('active', x.dataset.categoryLink === category));
    bindVariantPickers(grid);
    attachProductActions(grid);
    history.pushState({khatieCategory: category}, '', (window.KHATIE_ROOT || '/') + '?khatie_category=' + encodeURIComponent(category) + '#category-shop-page');
    page.scrollIntoView({behavior:'smooth', block:'start'});
  }

  addEventListener('popstate', () => {
    const requested = new URLSearchParams(location.search).get('khatie_category');
    if (requested && copy[requested]) showCategoryPage(requested);
    else { exitCategoryPage(); if ($('[data-category-bar]')) showCategoryInline('Edible Oils'); }
  });
  $$('a[href^="#"]').forEach(a => a.addEventListener('click', e => {
    if (a.hasAttribute('data-inline-category') || a.hasAttribute('data-category-link')) return;
    const id = a.getAttribute('href').slice(1); if (!id) return;
    const target = document.getElementById(id);
    if (target) { e.preventDefault(); if (id === 'catalog') filter('All'); target.scrollIntoView({behavior:'smooth', block:'start'}); }
  }));

  $('[data-catalog-search]')?.addEventListener('input', e => {
    const q = e.target.value.toLowerCase().trim();
    const mainGrid = $('[data-product-grid]');
    if (!mainGrid) return;
    $$('[data-product-card]', mainGrid).forEach(c => c.style.display = !q || (c.dataset.title || '').toLowerCase().includes(q) ? '' : 'none');
  });

  // Cart page: quantity buttons, remove, direct update and checkout.
  const cartForm = $('[data-cart-form]');
  if (cartForm) {
    const checkoutButton = $('[name="checkout"]', cartForm);
    // Shipping fees and delivery messaging are handled at checkout.
    // No theme-level small-cart fee or delivery-rule panel is rendered here.
    const minOrder = Number(cartForm.dataset.minOrder || 24900);
    const minOrderMessage = $('[data-min-order-message]', cartForm);
    const updateMinimumOrder = () => {
      const subtotal = Number(cartForm.dataset.cartSubtotal || 0);
      const remaining = Math.max(0, minOrder - subtotal);
      if (checkoutButton) {
        checkoutButton.disabled = remaining > 0;
        checkoutButton.toggleAttribute('aria-disabled', remaining > 0);
      }
      if (minOrderMessage) {
        if (remaining > 0) {
          minOrderMessage.textContent = `Minimum order value is ₹249. Add ₹${Math.ceil(remaining / 100)} more to place your order.`;
          minOrderMessage.hidden = false;
        } else {
          minOrderMessage.textContent = '✓ Minimum order value reached. You can place your order.';
          minOrderMessage.hidden = false;
        }
      }
    };
    updateMinimumOrder();

    const setBusy = (item, busy) => item?.classList.toggle('is-updating', busy);
    const updateLine = async (item, quantity) => {
      const key = item?.dataset.lineKey;
      if (!key) return;
      setBusy(item, true);
      try { await changeLine(key, Math.max(0, Number(quantity))); window.location.reload(); }
      catch (err) { toast(err.message); setBusy(item, false); }
    };
    $$('[data-qty-plus]', cartForm).forEach(b => b.addEventListener('click', () => {
      const item = b.closest('[data-cart-item]'); const input = $('[data-qty-input]', item);
      updateLine(item, Number(input?.value || 0) + 1);
    }));
    $$('[data-qty-minus]', cartForm).forEach(b => b.addEventListener('click', () => {
      const item = b.closest('[data-cart-item]'); const input = $('[data-qty-input]', item);
      updateLine(item, Math.max(0, Number(input?.value || 0) - 1));
    }));
    $$('[data-remove-line]', cartForm).forEach(b => b.addEventListener('click', () => {
      const item = b.closest('[data-cart-item]'); updateLine(item, 0);
    }));
    $$('[data-qty-input]', cartForm).forEach(input => {
      input.addEventListener('change', () => updateLine(input.closest('[data-cart-item]'), input.value));
      input.addEventListener('keydown', e => { if (e.key === 'Enter') { e.preventDefault(); updateLine(input.closest('[data-cart-item]'), input.value); } });
    });

    cartForm.addEventListener('submit', e => {
      const submitter = e.submitter;
      if (submitter?.name !== 'checkout') return;
      const subtotal = Number(cartForm.dataset.cartSubtotal || 0);
      if (subtotal < minOrder) {
        e.preventDefault();
        updateMinimumOrder();
        toast(`Minimum order value is ₹249. Add ₹${Math.ceil((minOrder - subtotal) / 100)} more.`);
      }
    });
  }

  // Reveal animations.
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); } }), {threshold:.12});
    $$('.category-feature,.kh-category-showcase,.statement,.promise,.shop-strip,.product-card,.category-shop-page').forEach(e => { e.classList.add('reveal'); io.observe(e); });
  }

  function initCategoryFromURL() {
    const params = new URLSearchParams(location.search);
    const requested = params.get('khatie_category');
    if (!requested || !$('[data-category-bar]')) return;
    const valid = Object.prototype.hasOwnProperty.call(copy, requested) || requested === 'All';
    if (!valid) return;
    setTimeout(() => {
      if (requested === 'All') {
        exitCategoryPage();
        filter('All');
        history.replaceState({}, '', (window.KHATIE_ROOT || '/') + '#catalog');
        scrollToId('catalog');
      } else {
        if (location.hash === '#category-shop-page') showCategoryPage(requested);
        else { showCategoryInline(requested); scrollToId('shop'); }
      }
    }, 60);
  }

  function initCategoryScrollDepth() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const bar = $('[data-category-bar]');
    if (!bar || bar.dataset.scrollDepthBound) return;
    bar.dataset.scrollDepthBound = '1';
    let raf = 0;
    const update = () => {
      const panel = $('[data-category-inline-panel]', bar);
      if (!panel) return;
      const r = panel.getBoundingClientRect();
      const vh = window.innerHeight || 800;
      const progress = Math.max(-1, Math.min(1, (vh * .72 - (r.top + r.height * .5)) / Math.max(vh, r.height)));
      const y = progress * 38;
      const x = progress * 16;
      panel.style.setProperty('--scroll-y', y.toFixed(1) + 'px');
      panel.style.setProperty('--scroll-x', x.toFixed(1) + 'px');
      panel.style.setProperty('--scroll-orb-x', (x * .7).toFixed(1) + 'px');
      panel.style.setProperty('--scroll-orb-y', (y * .65).toFixed(1) + 'px');
      panel.style.setProperty('--scroll-ring-x', (x * .45).toFixed(1) + 'px');
      panel.style.setProperty('--scroll-ring-y', (y * .35).toFixed(1) + 'px');
    };
    const onScroll = () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(update); };
    addEventListener('scroll', onScroll, {passive:true});
    addEventListener('resize', onScroll, {passive:true});
    update();
  }

  addEventListener('resize', updateSwipeHint, {passive:true});

  function initMainProductVariants(root = document) {
    $$('[data-main-product]', root).forEach(productRoot => {
      if (productRoot.dataset.mainProductBound) return;
      productRoot.dataset.mainProductBound = '1';

      const buttons = $$('[data-main-variant]', productRoot);
      const galleries = $$('[data-variant-gallery]', productRoot);
      const price = $('[data-main-product-price]', productRoot);
      const idInput = $('[data-main-product-id]', productRoot);
      const add = $('[data-main-product-add]', productRoot);
      const buy = $('[data-buy-now]', productRoot);

      const initGallery = gallery => {
        if (gallery.dataset.galleryBound) return;
        gallery.dataset.galleryBound = '1';
        const slides = $$('[data-gallery-slide]', gallery);
        const thumbs = $$('[data-gallery-thumb]', gallery);
        const prev = $('[data-gallery-prev]', gallery);
        const next = $('[data-gallery-next]', gallery);
        const count = $('[data-gallery-count]', gallery);
        let index = 0;

        const show = (nextIndex, animate = true) => {
          if (!slides.length) return;
          index = (nextIndex + slides.length) % slides.length;
          slides.forEach((slide, i) => {
            slide.classList.toggle('is-active', i === index);
            if (animate) slide.classList.toggle('is-changing', i === index);
          });
          thumbs.forEach((thumb, i) => thumb.classList.toggle('is-active', i === index));
          if (count) count.textContent = `${index + 1} / ${slides.length}`;
          if (animate) setTimeout(() => slides.forEach(slide => slide.classList.remove('is-changing')), 220);
        };

        prev?.addEventListener('click', e => { e.preventDefault(); show(index - 1); });
        next?.addEventListener('click', e => { e.preventDefault(); show(index + 1); });
        thumbs.forEach(thumb => thumb.addEventListener('click', e => {
          e.preventDefault();
          show(Number(thumb.dataset.galleryThumb || 0));
        }));

        let touchStart = 0;
        const windowEl = $('.main-product__gallery-window', gallery);
        windowEl?.addEventListener('touchstart', e => { touchStart = e.changedTouches[0].clientX; }, {passive:true});
        windowEl?.addEventListener('touchend', e => {
          const dx = e.changedTouches[0].clientX - touchStart;
          if (Math.abs(dx) > 45) show(index + (dx < 0 ? 1 : -1));
        }, {passive:true});

        show(0, false);
      };

      galleries.forEach(initGallery);

      const select = button => {
        buttons.forEach(x => x.classList.toggle('is-selected', x === button));
        const id = button.dataset.variantId || '';
        const available = button.dataset.variantAvailable === 'true';
        if (idInput) idInput.value = id;
        if (price) price.textContent = button.dataset.variantPrice || '';
        if (add) { add.disabled = !available; add.textContent = available ? 'Add to cart' : 'Sold out'; }
        if (buy) { buy.disabled = !available; buy.dataset.variantId = id; buy.textContent = available ? 'Buy now' : 'Unavailable'; }

        galleries.forEach(gallery => {
          const active = gallery.dataset.variantGallery === id;
          gallery.classList.toggle('is-active', active);
          gallery.hidden = !active;
          if (active) {
            const activeSlide = $('[data-gallery-slide].is-active', gallery);
            if (!activeSlide) $('[data-gallery-slide]', gallery)[0]?.classList.add('is-active');
          }
        });

        if (button.dataset.variantUrl) {
          const u = new URL(button.dataset.variantUrl, window.location.origin);
          history.replaceState({}, '', u.pathname + '?variant=' + encodeURIComponent(id));
        }
      };

      buttons.forEach(button => button.addEventListener('click', () => select(button)));
      const requested = new URLSearchParams(location.search).get('variant');
      const requestedButton = requested ? buttons.find(b => b.dataset.variantId === requested) : null;
      const initialButton = requestedButton || buttons.find(b => b.classList.contains('is-selected')) || buttons[0];
      if (initialButton) select(initialButton);
    });
  }

  function initDynamicThemeParts() {
    const activeCategory = $$('.category-pill.active')[0]?.dataset.categoryLink || 'Edible Oils';
    if ($('[data-inline-category-grid]')) showCategoryInline(activeCategory);
    if ($('[data-category-grid]')) renderQuickShop(activeCategory);
    bindVariantPickers();
    initMainProductVariants();
  attachProductActions();
  initProductGalleries();
    refreshCartCount();
  }


  // Khatie fallback info pages. These keep footer/help links usable even before
  // the merchant creates the corresponding Shopify Page resources.
  function initKhatieInfoModal() {
    const getModal = () => $('[data-khatie-info-modal]');
    const getData = () => {
      const el = $('[data-khatie-info-data]');
      try { return JSON.parse(el?.textContent || '{}'); } catch (_) { return {}; }
    };
    const open = key => {
      const modal = getModal();
      const data = getData();
      if (!modal) return;
      const item = data[key] || data.story;
      if (!item) return;
      const title = $('[data-khatie-info-title]', modal);
      const tag = $('[data-khatie-info-tag]', modal);
      const body = $('[data-khatie-info-body]', modal);
      if (tag) tag.textContent = item.tag || 'KHATIE';
      if (title) title.textContent = item.title || 'Khatie';
      if (body) body.innerHTML = item.body || '';
      modal.hidden = false;
      modal.setAttribute('aria-hidden','false');
      document.body.classList.add('khatie-modal-open');
    };
    const close = () => {
      const modal = getModal();
      if (!modal) return;
      modal.hidden = true;
      modal.setAttribute('aria-hidden','true');
      document.body.classList.remove('khatie-modal-open');
    };
    document.addEventListener('click', e => {
      const link = e.target.closest('[data-khatie-info-link]');
      if (link) { e.preventDefault(); open(link.dataset.khatieInfoLink); return; }
      if (e.target.closest('[data-khatie-info-close]')) { e.preventDefault(); close(); }
    });
    document.addEventListener('keydown', e => { if (e.key === 'Escape') close(); });
    const params = new URLSearchParams(location.search);
    const key = params.get('khatie_info');
    if (key) setTimeout(() => open(key), 80);
  }

  initKhatieInfoModal();

  initDynamicThemeParts();
  initMainProductVariants();
  initCategoryScrollDepth();
  initCategoryFromURL();

  // Subtle pointer depth for the category experience. It stays disabled on
  // touch devices and respects reduced-motion preferences.
  function initCategoryDepth() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !window.matchMedia('(pointer: fine)').matches) return;
    document.querySelectorAll('[data-category-bar]').forEach(bar => {
      if (bar.dataset.depthBound) return;
      bar.dataset.depthBound = '1';
      let raf = 0;
      const move = e => {
        const r = bar.getBoundingClientRect();
        const x = ((e.clientX - r.left) / r.width - .5) * 2;
        const y = ((e.clientY - r.top) / r.height - .5) * 2;
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          bar.style.setProperty('--depth-x', (x * 7).toFixed(2) + 'px');
          bar.style.setProperty('--depth-y', (y * 4).toFixed(2) + 'px');
        });
      };
      const leave = () => {
        bar.style.setProperty('--depth-x','0px');
        bar.style.setProperty('--depth-y','0px');
      };
      bar.addEventListener('pointermove', move, {passive:true});
      bar.addEventListener('pointerleave', leave, {passive:true});
    });
  }
  initCategoryDepth();

  // Premium 3D pointer depth for hero + feature visuals. Disabled on touch/reduced-motion.
  function initPremiumDepth(){
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !window.matchMedia('(pointer: fine)').matches) return;
    document.querySelectorAll('.kh-hero-v2-stage, .feature-visual').forEach(el=>{
      if(el.dataset.premiumDepthBound) return;
      el.dataset.premiumDepthBound='1';
      let raf=0;
      const move=e=>{
        const r=el.getBoundingClientRect();
        const x=((e.clientX-r.left)/r.width-.5)*2;
        const y=((e.clientY-r.top)/r.height-.5)*2;
        cancelAnimationFrame(raf);
        raf=requestAnimationFrame(()=>{
          const px=(x*12).toFixed(2)+'px', py=(y*8).toFixed(2)+'px';
          el.style.setProperty('--hero-depth-x',px);
          el.style.setProperty('--hero-depth-y',py);
          el.style.setProperty('--hero-tilt-y',(x*3).toFixed(2)+'deg');
          el.style.setProperty('--hero-tilt-x',(y*-2).toFixed(2)+'deg');
          el.style.setProperty('--feature-x',px);
          el.style.setProperty('--feature-y',py);
          el.style.setProperty('--feature-tilt',(x*3).toFixed(2)+'deg');
          el.style.setProperty('--card-one-x',(x*9).toFixed(2)+'px');
          el.style.setProperty('--card-one-y',(y*6).toFixed(2)+'px');
          el.style.setProperty('--card-two-x',(x*-7).toFixed(2)+'px');
          el.style.setProperty('--card-two-y',(y*-5).toFixed(2)+'px');
        });
      };
      const leave=()=>{
        ['--hero-depth-x','--hero-depth-y','--hero-tilt-y','--hero-tilt-x','--feature-x','--feature-y','--feature-tilt','--card-one-x','--card-one-y','--card-two-x','--card-two-y'].forEach(v=>el.style.setProperty(v,'0px'));
      };
      el.addEventListener('pointermove',move,{passive:true});
      el.addEventListener('pointerleave',leave,{passive:true});
    });
  }
  initPremiumDepth();

  // Shopify Theme Editor replaces section DOM without re-running the page script.
  // Re-initialize category/product interactions whenever a section is loaded or re-rendered.
  document.addEventListener('shopify:section:load', () => {
    setTimeout(() => { initDynamicThemeParts(); initMainProductVariants(); initCategoryScrollDepth(); initProductGalleries(); }, 0);
  });
  document.addEventListener('shopify:section:reorder', () => {
    setTimeout(() => { initDynamicThemeParts(); initMainProductVariants(); initCategoryScrollDepth(); initProductGalleries(); }, 0);
  });
  document.addEventListener('shopify:section:select', () => {
    setTimeout(() => { initDynamicThemeParts(); initMainProductVariants(); initCategoryScrollDepth(); initProductGalleries(); }, 0);
  });
})();
